import { Chip, Divider, IconButton } from "@mui/material";
import { BaseInput, Ptag } from "components/core";
import React from "react";
import { Error } from "components/PlanSetup/styles";
import AddIcon from "assets/svgs/add_circle.svg";
import { FieldArray } from "formik";
import { colors } from "theme";
import { RemoveCircleOutline } from "@mui/icons-material";

const TpaCashless = ({ formikProps, index }) => {
  const handlePhoneKeyPress = (e) => {
    const controlKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End'
    ];

    if (e.ctrlKey || e.metaKey) {
      return;
    }

    if (controlKeys.includes(e.key)) {
      return;
    }

    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handlePhonePaste = (e) => {
    e.preventDefault();

    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData('text');

    const numericValue = pastedText.replace(/\D/g, '').slice(0, 16);

    const input = e.target;
    const fieldName = input.name;

    input.value = numericValue;

    const syntheticEvent = {
      target: {
        name: fieldName,
        value: numericValue
      }
    };

    formikProps.handleChange(syntheticEvent);
  };

  const handlePhoneInputEvent = (e) => {
    const input = e.target;
    let value = input.value;

    const numericValue = value.replace(/\D/g, '');

    const limitedValue = numericValue.slice(0, 16);

    if (input.value !== limitedValue) {
      input.value = limitedValue;

      formikProps.setFieldValue(input.name, limitedValue);
    }
  };

  const addSegment = (name, label, sub_index) => {
    const isPhoneField = name === "cashless_contact";
    const isNameField = name === "cashless_contact_name";
    const isEmailField = name === "cashless_contact_email";
    const fieldName = `cashless.${index}.${sub_index}.${name}`;

    const handleNameKeyPress = (e) => {
      const controlKeys = [
        'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Home', 'End'
      ];

      if (e.ctrlKey || e.metaKey) {
        return;
      }

      if (controlKeys.includes(e.key)) {
        return;
      }

      if (isNameField && !/^[a-zA-Z\s]$/.test(e.key)) {
        e.preventDefault();
      }
    };

    const handleNamePaste = (e) => {
      if (!isNameField) return;

      e.preventDefault();

      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');

      const cleanValue = pastedText.replace(/[^a-zA-Z\s]/g, '');

      const input = e.target;
      const fieldName = input.name;

      input.value = cleanValue;

      const syntheticEvent = {
        target: {
          name: fieldName,
          value: cleanValue
        }
      };

      formikProps.handleChange(syntheticEvent);
    };

    return (
      <div
        style={{
          marginBottom: "3rem",
          position: "relative",
        }}
      >
        <BaseInput
          staticLabel={label}
          type={isPhoneField ? "tel" : (isEmailField ? "email" : "text")}
          fontSize="16px !important"
          inputProps={
            isPhoneField 
              ? { 
                  maxLength: 16,
                  pattern: "[0-9]*",
                  inputMode: "numeric",
                  autoComplete: "tel"
                } 
              : (isEmailField ? { autoComplete: "email" } : {})
          }
          formikProps={{
            ...formikProps,
            name: fieldName,
          }}
          onKeyDown={isPhoneField ? handlePhoneKeyPress : (isNameField ? handleNameKeyPress : undefined)}
          onPaste={isPhoneField ? handlePhonePaste : (isNameField ? handleNamePaste : undefined)}
          onInput={isPhoneField ? handlePhoneInputEvent : undefined}
        />
        {formikProps.errors &&
          formikProps.errors["cashless"] &&
          formikProps.errors["cashless"][index] &&
          formikProps.errors["cashless"][index][sub_index] &&
          formikProps.errors["cashless"][index][sub_index][name] && (
            <Error>
              {formikProps.errors["cashless"][index][sub_index][name]}
            </Error>
          )}
      </div>
    );
  };

  return (
    <section
      style={{
        marginBottom: "3rem",
      }}
    >
      <Chip
        label={`Level ${index + 1}`}
        sx={{
          borderRadius: "5px",
          fontSize: "12px",
          backgroundColor: "#452d84",
          color: "white",
          marginBottom: "1.4rem",
        }}
      />
      <FieldArray
        name={`cashless[${index}]`}
        render={({ push, pop }) => (
          <div>
            {formikProps.values.cashless[index].map((_, sub_index, array) => (
              <div key={sub_index}>
                {addSegment("cashless_contact_name", "Name", sub_index)}
                {addSegment("cashless_contact_email", "Email", sub_index)}
                {addSegment("cashless_contact", "Contact", sub_index)}
                {addSegment("cashless_region", "Region (optional)", sub_index)}
                {sub_index < array.length - 1 && (
                  <div
                    style={{
                      borderTop: `1px dashed ${colors.primaryColor}`,
                      margin: "36px 0",
                    }}
                  />
                )}
              </div>
            ))}
            {formikProps?.values?.cashless[index]?.length > 1 && (
              <IconButton
                sx={{
                  borderRadius: "5px",
                }}
                onClick={() => pop()}
              >
                <RemoveCircleOutline
                  style={{
                    marginRight: "0.5rem",
                    height: "22px",
                    width: "22px",
                    color: "#DE6944",
                  }}
                />
                <Ptag style={{ color: "#DE6944", fontSize: "14px", textDecoration: "underline" }}>
                  Remove Contact
                </Ptag>
              </IconButton>
            )}
            <IconButton
              sx={{
                borderRadius: "5px",
              }}
              onClick={() => push("")}
            >
              <img src={AddIcon} alt="" style={{ marginRight: "0.4rem" }} />
              <u style={{ color: "#002060", fontSize: "16px" }}>
                <Ptag fontSize='14px'>
                  Add Contact 
                </Ptag>
              </u>
            </IconButton>
            <Divider
              sx={{
                mt: "36px",
                mb: "10px",
                backgroundColor: "",
              }}
            />
          </div>
        )}
      />
    </section>
  );
};

export default TpaCashless;